import React, {useCallback, useMemo} from 'react';
import type {AstView, EnrichedAstNode} from 'rendition-core';

import TabbedButtonToggle from 'Components/Tailwind/TabbedButtonToggle';
import {useMultiNodeValue} from 'Hooks/useMultiNodeValue';

interface Props {
    view: AstView;
    setView: (view: AstView) => void;
    selectedNodes: EnrichedAstNode[];
}

const options: Array<{value: Exclude<React.CSSProperties['whiteSpace'], undefined>; icon: React.ReactNode}> = [
    {value: 'nowrap', icon: 'No'},
    {value: 'normal', icon: 'Yes'},
];

export const TextWrapToggle: React.FC<React.PropsWithChildren<Props>> = ({view, setView, selectedNodes}) => {
    const accessFn = useCallback((n: EnrichedAstNode) => n.styles.whiteSpace, []);
    const assignFn = useCallback(
        (n: EnrichedAstNode, v: React.CSSProperties['whiteSpace']) => (n.styles.whiteSpace = v),
        []
    );
    const {value, updateNodes} = useMultiNodeValue(selectedNodes, accessFn, assignFn);

    const allTextNodes = useMemo(() => selectedNodes.every((n) => n.type === 'Text'), [selectedNodes]);

    if (!allTextNodes) {
        return null;
    }

    return (
        <div className="flex w-full flex-col items-start justify-between gap-4">
            <h1 className="text-xs font-extrabold capitalize text-white">Text Wrap</h1>
            <TabbedButtonToggle
                classNames="self-stretch ml-3"
                value={value || 'normal'}
                items={options}
                onClick={updateNodes}
            />
        </div>
    );
};
